export default {"src":"/_next/static/media/4.9ccdd355.svg","height":39,"width":39,"blurWidth":0,"blurHeight":0};